


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import {
  CHOOSE_DATE_TIME_FORMAT
} from '@/system/store/action-types'
import { IActionType } from '@/system/store'
import { matchFieldsLocalisationKeys } from '@/features/matchFields/matchFields.localisation'

@Component
export default class ChooseTimeFormat extends Vue {
  public translations = matchFieldsLocalisationKeys
  public timeOptions: string[] = [
    'H:mm:ss',
    'HH:mm:ss',
    'H:mm',
    'H:m',
    'HH:mm',
    'h:mm:ss a',
    'hh:mm:ss a',
    'h:mm a',
    'h:m a',
    'hh:mm a',
    'HHmm',
    'HHmmss'
  ]
  public dateOptions: string[] = [
    'dd-MM-yyyy',
    'dd/MM/yyyy',
    'd-M-yy',
    'd-M-yyyy',
    'd/M/yy',
    'd/M/yyyy',
    'MM-dd-yyyy',
    'MM/dd/yyyy',
    'M/d/yyyy',
    'M/d/yy',
    'yyyy-MM-dd',
    'yy-MM-dd',
    'dd-MM-yy',
    'MM-dd-yy',
    'yyyyMMdd',
    'ddMMyyyy',
    'MMddyyyy'
  ]
  public selectedDateFormat: string = this.dateOptions[0]
  public selectedTimeFormat: string = this.timeOptions[0]

  @Action(CHOOSE_DATE_TIME_FORMAT)
  updateDateTimeFormat!: IActionType

  @Watch('selectedDateFormat')
  changedDateFormat () {
    this.updateDateTimeFormat(`${this.selectedDateFormat}'T'${this.selectedTimeFormat}`)
    this.$emit('runValidation')
  }

  @Watch('selectedTimeFormat')
  changedTimeFormat () {
    this.updateDateTimeFormat(`${this.selectedDateFormat}'T'${this.selectedTimeFormat}`)
    this.$emit('runValidation')
  }
}
